import { useNavigate } from "react-router-dom";
import wekitLogo from "@/assets/wekit-logo.jpg";

interface WeKitLogoProps {
  size?: "sm" | "md" | "lg";
  className?: string;
  /** Set to false to render a non-interactive logo (e.g. inside body content). Default true. */
  clickable?: boolean;
}

export default function WeKitLogo({
  size = "md",
  className = "",
  clickable = true,
}: WeKitLogoProps) {
  const navigate = useNavigate();
  const sizes = {
    sm: "h-9 w-9",
    md: "h-11 w-11",
    lg: "h-14 w-14",
  };

  const handleClick = (e: React.MouseEvent) => {
    if (!clickable) return;
    // Stop bubbling so we override any parent <Link> wrapper and always go home.
    e.preventDefault();
    e.stopPropagation();
    navigate("/");
  };

  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (!clickable) return;
    if (e.key === "Enter" || e.key === " ") {
      e.preventDefault();
      e.stopPropagation();
      navigate("/");
    }
  };

  return (
    <span
      role={clickable ? "link" : undefined}
      tabIndex={clickable ? 0 : undefined}
      aria-label={clickable ? "Go to WeKIT™ home" : undefined}
      onClick={handleClick}
      onKeyDown={handleKeyDown}
      className={`inline-flex items-center justify-center bg-white p-1 ${
        clickable ? "cursor-pointer transition-transform hover:scale-105 focus:outline-none focus-visible:ring-2 focus-visible:ring-primary rounded" : ""
      } ${sizes[size]} ${className}`}
    >
      <img
        src={wekitLogo}
        alt="WeKIT™ Logo"
        className="h-full w-full object-contain pointer-events-none"
        draggable={false}
      />
    </span>
  );
}
